import { useSelector } from "react-redux";
import "./AdControl.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import Select from "react-select";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Popover,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { FiSearch } from "react-icons/fi";
import SyncIcon from '@mui/icons-material/Sync';
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { GridLoader, ScaleLoader } from "react-spinners";
import { formatStringToNumberV2, logData } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { MdClose, MdSave } from "react-icons/md";
import { useTranslation } from "react-i18next";

const AdControl = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [savingTitle, setSavingTitle] = useState("Save");
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState({});
  const [profileLimits, setProfileLimits] = useState([]);
  const [selectedProfileLimit, setSelectedProfileLimit] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermLimits, setSearchTermLimits] = useState("");
  const [pfCode, setPfCode] = useState(null);
  const [pfName, setPfName] = useState(null);
  const [pfEnabled, setPfEnabled] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);



  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });


  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 8));
    setCurrentPage(0);
  };

  const fetchProfiles = async () => {
    try {
      const res = await newRequest.get("/adProfile/findAll");
      setProfiles(res.data);
      setSelectedProfile(res.data[0]);
      await fetchProfileLimits(res.data[0]._id);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await newRequest.post("/uwProduct/findAll", { lean: "" });
      let options = res.data?.map((product) => ({
        value: product?.pr_code,
        label: product?.pr_name,
      }));
      options = [...options,
      { value: "ar", label: "AC Receivables" },
      { value: "ap", label: "AC Payables" },
      { value: "gl", label: "General Ledger" },
      { value: "gb", label: "Global" }];
      setProducts(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const fetchProfileLimits = async (profileDocId, productCode = null) => {
    try {
      setIsProcessing(true);
      const res = await newRequest.post(
        "/adProfile/getLimits",
        {
          profile_docid: profileDocId,
          product_code: productCode
        }
      );
      // console.log(`fetchProfileLimits  ${JSON.stringify(res.data, null, 2)}`);
      if (res.data) {
        const formattedData = res.data?.map(item => ({
          ...item,
          limit_value: formatNumber(item.limit_value)
        }));
        setProfileLimits(formattedData);
        setSelectedProfileLimit(formattedData[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSearchLimit = async () => {
    try {
      if (searchTermLimits) {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/adProfile/searchLimit",
          {
            search_input: searchTermLimits,
            profile_docid: selectedProfile?._id,
            product_code: selectedProduct?.value
          }
        );
        // console.log(`/searchLimit  ${JSON.stringify(res.data, null, 2)}`);

        const formattedData = res.data?.map(item => ({
          ...item,
          limit_value: formatNumber(item.limit_value)
        }));
        // console.log(`/formattedData  ${JSON.stringify(formattedData, null, 2)}`);
        setProfileLimits(formattedData);
        // setSelectedProfileLimit(formattedData[0]);
        setIsProcessing(false);
      }
    } catch (error) {
      console.error("Error searching data:", error);
    }
  };

  const slicedProfileLimits = profileLimits?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const formatNumber = (value) => {
    // console.log(`formatNumber passed value is ${value} and is is a number ${isNaN(value)}`)
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };


  useEffect(() => {
    try {
      setPfCode(selectedProfile.pf_code);
      setPfName(selectedProfile.pf_name);
      setPfEnabled(selectedProfile.pf_enabled);
      fetchProfileLimits(selectedProfile._id);
    } catch (error) {
      console.log(error);
    }
  }, [selectedProfile]);

  useEffect(() => {
    try {
      if (selectedProduct?.value) {
        fetchProfileLimits(selectedProfile._id, selectedProduct?.value);
      } else {
        fetchProfileLimits(selectedProfile._id);
      }
      setCurrentPage(0);
    } catch (error) {
      console.log(error);
    }
  }, [selectedProduct]);


  useEffect(() => {
    fetchProfiles();
    fetchProducts();
  }, []);

  const filteredProfiles = profiles?.filter(
    (item) =>
      item?.pf_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.pf_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const slicedDataLimits = profileLimits?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );


  const syncProfiles = async () => {
    try {
      setIsConfirmDialogOpen(false);
      setIsProcessing(true);
      setIsLoading(false);
      await newRequest.get("/adProfile/sync");
      fetchProfileLimits(selectedProfile._id);
      setIsProcessing(false);
      showToast("Synchronizion completed!", "success");
    } catch (error) {
      console.log(error)
    }
  }

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteLimit") {
        await newRequest.post(
          "/adProfile/delLimit",
          {
            profile_docid: selectedProfile._id,
            profile_limit_docid: objectToAction.object_id,
          }
        );
        fetchProfileLimits(selectedProfile._id);
      } else if (confirmDialogAction === "syncProfile") {
        try {
          syncProfiles();
        } catch (error) {
          console.log(error)
        } finally {
          setIsProcessing(false)
        }
      } else if (confirmDialogAction === "deleteProfile") {
        const delProfile = await newRequest.delete(`/adProfile/del/${objectToAction.object_id}`);
        // console.log(`${delProfile.data} and status ${delProfile.status}`)
        if (delProfile.data === "deleted") {
          // Remove the deleted profile from the state
          //  setProfiles(profiles.filter(profile => objectToAction.object_id !== id));
          const updatedProfiles = profiles.filter(profile => profile._id !== id);
          setProfiles(updatedProfiles);
          if (updatedProfiles.length > 0) {
            setSelectedProfile(updatedProfiles[0]);
          } else {
            setSelectedProfile(null);
          }

          showToast("Deleted!", "success");
        } else {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(delProfile.data);
          setIsNotifyDialogOpen(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      setSavingTitle("saving...");
      setIsProcessing(true);

      // update profile details
      await newRequest.post(
        "/adProfile/upd",
        {
          profile_docid: selectedProfile._id,
          pf_code: pfCode,
          pf_name: pfName,
          pf_enabled: pfEnabled,
          userCode: currentUser.usr_id,
        }
      );

      // const updatedData = [...profiles];
      // const currentRow = updatedData[selectedProfileIndex];
      // currentRow["pf_enabled"] = pfEnabled;
      // setProfiles(updatedData);

      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const changedLimits = profileLimits?.filter(
        (obj) => obj.changed_xx === "Y"
      );
      for (let i = 0; i < changedLimits.length; i++) {
        const res = await newRequest.post(
          "/adProfile/updLimit",
          {
            profile_docid: selectedProfile._id,
            profile_limit_docid: changedLimits[i]._id,
            limit_value: formatStringToNumberV2(changedLimits[i].limit_value),
            limit_yn: changedLimits[i].limit_yn,
            userCode: currentUser.usr_id,
          }
        );
      }
      fetchProfileLimits(selectedProfile._id);
      showToast("Updated!", "success");
    } catch (err) {
      console.log(err);
    } finally {
      setSavingTitle("Save");
      setIsProcessing(false);
    }
  };


  // const handleLimitChange = (e, rowId) => {
  //   try {
  //     const { name, value } = e.target;
  //     const updatedData = [...profileLimits];
  //     const rowIndex = updatedData.findIndex(item => item._id === rowId);
  //     if (rowIndex === -1) {
  //       throw new Error('Row not found');
  //     }
  //     updatedData[rowIndex][name] = value;
  //     updatedData[rowIndex]["changed_xx"] = "Y";
  //     // console.log(`rowId is ${rowId} handleLimitChange updatedData  \n${JSON.stringify(updatedData, null, 2)}`);
  //     setProfileLimits(updatedData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleLimitChange = (value, rowId, field) => {
    setProfileLimits((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [field]: value, changed_xx: "Y" }
          : item
      )
    );
  };

  const handleLimitBlur = (rowId, field) => {
    try {
      const updatedData = [...profileLimits];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }

      let value = updatedData[rowIndex][field];
      const numberFields = ["limit_value"];

      if (numberFields.includes(field)) {
        if (value) {
          value = formatNumber(formatStringToNumberV2(value));
        } else {
          value = updatedData[rowIndex][field];
        }
      }

      updatedData[rowIndex][field] = value;
      setProfileLimits(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const [newProfileName, setNewProfileName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;

  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setNewProfileName("");
    setAnchorEl(null);
  };

  const handleAddProfile = async () => {
    try {

      if (!newProfileName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter profile name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // generate profile code 
      const profileCode = await newRequest.post(
        "/orgNumgen/gen",
        {
          gen_org_code: currentUser.usr_org_code,
          gen_type: "Profile",
        }
      );

      if (profileCode.data) {
        await newRequest.post(
          "/adProfile/add",
          {
            pf_org_code: currentUser.usr_org_code,
            pf_code: profileCode.data,
            pf_name: newProfileName,
            userCode: currentUser.usr_id,
          }
        );
        const addedName = newProfileName;
        handlePopoverClose();
        syncProfiles();
        showToast(`${addedName} added!`, "success");
        fetchProfiles();
      } else {
        setNotifyDialogTitle("Error!");
        setNotifyDialogText(`Unable to generate profile code!`);
        setIsNotifyDialogOpen(true);
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="ad-control">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="ad-control-main-wrapper">
          <div className="ad-control-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <span className="page-title">{selectedProfile?.pf_name?.toUpperCase()}</span>
                </div>
                <div className="navbar-right">
                  {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#00D37F"
                      tooltip="Save changes"
                      endIcon={<MdSave />}
                      onClick={saveRecord}
                    >
                      {t('save')}
                    </CustomLoadingButton>}
                  {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#0ea5a4"
                      tooltip={"Add new profile"}
                      endIcon={<AddIcon />}
                      onClick={handlePopoverClick}
                    >
                      {t('newProfile')}
                    </CustomLoadingButton>}
                  <Popover
                    id={id}
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'bottom',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <div style={{ padding: "20px" }}>
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "max-content",
                        marginBottom: "5px"
                      }}>
                        <h1 className="main-title">{t('addProfile').toUpperCase()}</h1>
                        <CircularButton currentTheme={currentTheme} onClick={handlePopoverClose} icon={<MdClose />} width={"35px"} height={"35px"} />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="new_profile_name"
                          style={{ width: "50px" }}
                        >
                          {t('name').toUpperCase()}
                        </label>
                        <input
                          id="new_profile_name"
                          name="new_profile_name"
                          type="text"
                          placeholder={t('name').toUpperCase()}
                          value={newProfileName}
                          onChange={(e) => setNewProfileName(e.target.value)}
                          className="form-input-item"
                          style={{ width: "160px" }}
                        />
                        <span style={{ display: "flex", margin: "0px 10px" }}>
                          <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            endIcon={<AddIcon />}
                            onClick={handleAddProfile}
                          >
                            {t('add').toUpperCase()}
                          </CustomLoadingButton>
                        </span>
                      </div>
                    </div>
                  </Popover>
                  {["superadmin"].includes(currentUser.user_type_xx) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#f8e823"
                      tooltip={"Synchronize all profiles"}
                      endIcon={<SyncIcon />}
                      onClick={() => {
                        try {
                          let action_text = `Sync all profiles?`;
                          setObjectToAction({
                            object_id: selectedProfile._id,
                            action_text: action_text,
                            new_doc_status: "syncProfile",
                          });
                          setConfirmDialogAction("syncProfile");
                          setIsConfirmDialogOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('syncProfile')}
                    </CustomLoadingButton>}
                  {["superadmin"].includes(currentUser.user_type_xx) &&
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#f55656"
                      tooltip={`Delete ${selectedProfile.pf_name}`}
                      endIcon={<DeleteIcon />}
                      onClick={() => {
                        try {
                          let action_text = `Delete ${selectedProfile.pf_name}?`;
                          setObjectToAction({
                            object_id: selectedProfile._id,
                            action_text: action_text,
                            new_doc_status: "deleteProfile",
                          });
                          setConfirmDialogAction("deleteProfile");
                          setIsConfirmDialogOpen(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      {t('delete')}
                    </CustomLoadingButton>}
                </div>
              </div>
              <div className="form-details-wrapper">
                <div className="form-details-left">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pf_name"
                      style={{
                        width: "100px",
                      }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="pf_name"
                      name="pf_name"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={pfName}
                      onChange={(e) => {
                        try {
                          const updatedData = [...profiles];
                          // const currentRow = updatedData[selectedProfileIndex];
                          // currentRow["pf_name"] = e.target.value;
                          setProfiles(updatedData);
                          setPfName(e.target.value);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      className="form-input-item"
                      style={{ width: "400px" }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="pf_code"
                      style={{
                        width: "100px",
                      }}
                    >
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      id="pf_code"
                      name="pf_code"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={pfCode}
                      className="form-input-item"
                      style={{ width: "100px" }}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-details-right">
                  <ToggleSwitch
                    id="pf_enabled"
                    value={pfEnabled}
                    onChange={setPfEnabled}
                    label={t('enabled').toUpperCase()}
                    labelWidth="max-content"
                    disabled={false}
                    border="N"
                    style={{
                      width: "250px",
                    }}
                  />
                </div>
              </div>
              <hr className="separator-h" />
              <h2 className="main-title">{t('limits').toUpperCase()}</h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  paddingRight: "10px",
                  marginBottom: "10px"
                }}
              >
                <div className="homeSearch" style={{ display: "flex", flex: "1", height: "42px", marginTop: "0px", borderRadius: "8px" }}>
                  <FiSearch className="homeSearchIcon" />
                  <input
                    className="homeSearchInput"
                    type="text"
                    placeholder={`${t('search')} ${t('limits')}...`}
                    value={searchTermLimits}
                    onChange={(e) => setSearchTermLimits(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') handleSearchLimit();
                    }}
                  />
                  {searchTermLimits?.length > 0 ? (
                    <MdClose
                      className="homeSearchClear"
                      onClick={async () => {
                        try {
                          setSearchTermLimits("");
                          await fetchProfileLimits(selectedProfile?._id);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                  ) : (
                    <span className="homeSearchClearPlaceholder" />
                  )}
                </div>
                <div style={{ display: "flex", flex: "1", justifyContent: "flex-end" }}>
                  <div className="input-item-with-label" style={{ width: "100%" }}>
                    <Select
                      id="product_code"
                      name="product_code"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="100%"
                      value={selectedProduct}
                      onChange={async (selectedOption) => setSelectedProduct(selectedOption)}
                      options={products}
                      isClearable
                      isSearchable={true}
                      placeholder={t('filterByProductModule')}
                    />
                  </div>
                </div>
              </div>
              {profileLimits?.length > 0 &&
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell" style={{ maxWidth: "50px", fontWeight: "bold", display: "flex", alignItems: "center" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell" style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", maxWidth: "100px", flexDirection: "row" }}>
                            <span> {t('code').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ fontWeight: "bold", width: "auto", display: 'flex' }}>
                            <span> {t('name').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ fontWeight: "bold", width: "300px", display: 'flex' }}>
                            <span> {t('module').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell" style={{ fontWeight: "bold", alignItems: "center", display: 'flex', maxWidth: "200px", justifyContent: "center" }}>
                            <span> {t('value').toUpperCase()}</span>
                          </TableCell>
                          {/* {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                          <TableCell className="table-cell" style={{ fontWeight: "bold", maxWidth: "100px", alignItems: "center", textAlign: "center" }}>
                            <span>ACTION</span>
                          </TableCell>} */}
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedDataLimits?.map((row, index) => (
                          <TableRow
                            key={row._id}
                            className={`${selectedProfileLimit?._id === row._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => setSelectedProfileLimit(row)}
                          >
                            <TableCell className="table-cell" style={{ maxWidth: "50px", fontWeight: "bold", display: "flex", alignItems: "center" }}>
                              {currentPage * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell className="table-cell" style={{ display: "flex", fontWeight: "bold", maxWidth: "100px", flexDirection: "column" }}>
                              <span style={{ fontWeight: "400", fontSize: "18px" }}>{row.limit_code}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{ display: "flex", fontWeight: "bold", width: "auto", flexDirection: "column" }}>
                              <span>{row.limit_name_xx}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{ display: "flex", fontWeight: "bold", maxWidth: "300px", flexDirection: "column" }}>
                              <span>{row?.module_name_xx || row?.limit_module}</span>
                            </TableCell>
                            <TableCell className="table-cell" style={{ display: "flex", fontWeight: "bold", maxWidth: "200px", justifyContent: "center" }}>
                              {row.limit_type_xx !== "YN" &&
                                <div className="input-item-with-label">
                                  <input
                                    id="limit_value"
                                    name="limit_value"
                                    type="text"
                                    value={row.limit_value}
                                    onChange={(e) => handleLimitChange(e.target.value, row._id, "limit_value")}
                                    style={{ width: "100%", textAlign: "right" }}
                                    className="form-input-item table"
                                    onBlur={() => {
                                      handleLimitBlur(row._id, "limit_value");
                                    }}
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                  />
                                </div>}
                              {row.limit_type_xx === "YN" &&
                                // <Select
                                //   id="limit_yn"
                                //   name="limit_yn"
                                //   value={row.limit_yn}
                                //   onChange={(e) => handleLimitChange(e, row._id)}
                                //   variant="outlined"
                                //   size="small"
                                //   disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                //   sx={currentTheme === "dark" ? muiSelectStyles_dark().select : muiSelectStyles_light().select}
                                //   MenuProps={{
                                //     PaperProps: {
                                //       sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                //     }
                                //   }}
                                // >
                                //   <MenuItem value="Y" sx={{ height: '36px' }}>Yes</MenuItem>
                                //   <MenuItem value="N" sx={{ height: '36px' }}>No</MenuItem>
                                // </Select>
                                <ToggleSwitch
                                  value={row?.limit_yn}
                                  onChange={(newValue) => handleLimitChange(newValue, row._id, "limit_yn")}
                                  label=""
                                  labelPosition="end"
                                  labelWidth="max-content"
                                  border="N"
                                />
                              }
                            </TableCell>
                            {/* {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                            <TableCell className="table-cell" style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: 'space-around', padding: "3px", maxWidth: "100px", }}>
                              <Tooltip
                                title={`Remove ${row.limit_name_xx} from this profile?`}
                                placement="right"
                              >
                                <DeleteIcon
                                  size={50}
                                  style={{
                                    borderRadius: "5px",
                                    padding: "3px",
                                    alignSelf: "center",
                                    cursor: "pointer",
                                    color: "rgba(244, 67, 54)",
                                    backgroundColor: "rgba(244, 67, 54, 0.5)",
                                  }}
                                  onClick={() => {
                                    try {
                                      let action_text = `Remove ${row.limit_name_xx} from this profile?`;
                                      setObjectToAction({
                                        object_id: row._id,
                                        action_text: action_text,
                                        new_doc_status: "deleteLimit",
                                      });
                                      setConfirmDialogAction("deleteLimit");
                                      setIsConfirmDialogOpen(true);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                />
                              </Tooltip>
                            </TableCell>} */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    {profileLimits?.length > rowsPerPage &&
                      <TablePagination
                        rowsPerPageOptions={[8]}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleRowsPerPage}
                        component="div"
                        count={profileLimits?.length}
                        rows={profileLimits}
                        page={currentPage}
                        onPageChange={handlePageChange}
                      />}
                  </TableContainer>
                </div>}
            </div>
          </div>
          <div className="ad-control-right-wrapper">
            <div className="homeSearch">
              <FiSearch className="homeSearchIcon" />
              <input
                className="homeSearchInput"
                type="text"
                placeholder={`${t('search')} ${t('profiles')}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm?.length > 0 ? (
                <CloseIcon
                  className="homeSearchClear"
                  onClick={() => {
                    try {
                      setSearchTerm("");
                      setCurrentPage(0);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
              ) : (
                <span className="homeSearchClearPlaceholder" />
              )}
            </div>
            <div className="options-list">
              {filteredProfiles?.map((profile) => (
                <>
                  <span
                    key={profile._id}
                    className={`${selectedProfile._id === profile._id
                      ? "single-option active"
                      : "single-option"
                      }`}
                    onClick={async () => {
                      try {
                        setSearchTermLimits("");
                        setSelectedProfile(profile);
                        setSelectedProduct(null);
                        setCurrentPage(0);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <div className="title-row">
                      <span className="cy-title">{profile?.pf_name}</span>
                    </div>
                  </span>
                  {/* <hr className="separator-h" /> */}
                </>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}> {t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* {isCodeDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>{`${
                currencyAction === "addSysCode" ? "ADD CODE" : "ADD TYPE"
              }`}</span>
              <span
                onClick={() => {
                  try {
                    setNewCode(null);
                    setNewName(null);
                    setNewGrouping(null);
                    setIsCodeDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <IoClose
                  style={{
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    borderRadius: "50%",
                  }}
                />
              </span>
            </div>
            <div className="overlay-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="newName"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  NAME
                </label>
                <input
                  id="newName"
                  name="newName"
                  type="text"
                  placeholder="NAME"
                  value={newName}
                  className="form-input-item"
                  style={{ width: "250px" }}
                  onChange={(e) => setNewName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="newCode"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {currencyAction === "addSysCode" ? "CODE" : "TYPE"}
                </label>
                <input
                  id="newCode"
                  name="newCode"
                  type="text"
                  placeholder={
                    currencyAction === "addSysCode" ? "CODE" : "TYPE"
                  }
                  value={newCode}
                  className="form-input-item"
                  style={{ width: "150px" }}
                  onChange={(e) => {
                    try {
                      setNewCode(e.target.value);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
              </div>
              {currencyAction === "addSysCode" && (
                <div className="input-item-with-label">
                  <label
                    htmlFor="newGrouping"
                    className="form-dropdown-label"
                    style={{ width: "130px" }}
                  >
                    GROUPING
                  </label>
                  <input
                    id="newGrouping"
                    name="newGrouping"
                    type="text"
                    placeholder="GROUPING"
                    value={newGrouping}
                    className="form-input-item"
                    style={{ width: "150px" }}
                    onChange={(e) => setNewGrouping(e.target.value)}
                  />
                </div>
              )}
            </div>
            <div className="overlay-actions">
              {currencyAction === "addSysCode" && (
                <CustomButton onClick={handleAddSysCode}>ADD</CustomButton>
              )}
              {currencyAction === "addSysType" && (
                <CustomButton onClick={handleAddSysType}>ADD</CustomButton>
              )}
            </div>
          </div>
        </motion.div>
      )} */}
    </div>
  );
};

export default AdControl;
